module.exports = __webpack_public_path__ + "static/img/stained.2c6e5327.png";